module.exports = __webpack_public_path__ + "img/Share (1).34bbcd08.svg";